<style scoped lang="scss" type="text/scss">
    @media screen and (min-width: 95rem) {
        .special-competition-item {
            width: calc(33.3% - 1rem) !important;
        }
    }

    .special-competition-item {
        background-color: #F4F4F4;
        box-sizing: border-box;
        padding: .5rem 1rem;
        display: flex;
        width: calc(50% - 1rem);
        height: 8rem;
        border-radius: .15rem;

        .left-panel {
            width: 5rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            color: #999;
            position: relative;
            box-sizing: border-box;
            padding-bottom: .3rem;

            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: 20%;
                height: 60%;
                width: 1px;
                background-color: #DDD;
            }

            .icon-container {
                flex: 1;
                font-size: 2.7rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .text {
                height: 1.5rem;
                line-height: 0;
                text-align: center;
            }
        }

        .right-panel {
            flex: 1;
            box-sizing: border-box;
            padding: 0 0 1rem 1rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;

            .name-panel {
                display: flex;
                align-items: center;
                color: #666;
                font-size: 1.4rem;
                margin-top: 1rem;
            }

            .operation-panel {
                font-size: .85rem;
                margin-top: .5rem;
                color: #999;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .enroll-status {
                    color: #FF3333;

                    &.registered {
                        color: #409EFF;
                    }
                }
            }
        }
    }
</style>

<template>
    <div class="special-competition-item">
        <div class="left-panel">
            <div class="icon-container">
                <i class="icon">&#xe633;</i>
            </div>
            <span class="text">#{{ index }}</span>
        </div>
        <div class="right-panel">
            <div class="name-panel">
                <span class="global-text-ellipsis">{{ info.special_competition_name }}</span>
            </div>
            <div class="operation-panel global-text-ellipsis">
                <span v-if="editable && info.registered !== true">未报名</span>
                <span v-if="editable && info.registered === true">已成功报名</span>

                <status-tag v-if="!editable" :success="info.registered === true" positive-text="已成功报名" negative-text="未报名"></status-tag>

                <el-button v-if="editable && info.registered !== true" type="primary" plain size="mini"
                           :loading="operating" @click="register">
                    报名参赛
                </el-button>
                <el-button v-if="editable && info.registered === true" type="danger" plain size="mini"
                           :loading="operating" @click="cancelRegistration">
                    取消报名
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import StatusTag from '../../../components/status-tag/index';

    export default {
        name: '',
        components: {
            StatusTag
        },
        props: {
            index: {
                type: Number | String,
                default: 0
            },
            editable: {
                type: Boolean,
                default: false
            },
            info: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {
                operating: false
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId
            })
        },
        methods: {
            reload () {
                this.$emit('need-reload');
            },
            register () {
                this.$normalConfirm('确认报名？', '报名后如有变化，可在截止前取消').then(_ => {
                    this.$normalRequest('player/registerSpecialCompetition', {
                        player_id: this.currentManagedPlayerId,
                        special_competition_id: this.info.special_competition_id
                    }, '报名成功', true, this, 'operating').then(_ => {
                        this.reload();
                    }).catch(_ => {
                    });
                }).catch(() => {
                });
            },
            cancelRegistration () {
                this.$normalConfirm('确认取消？', '取消后，可在截止前重新报名').then(_ => {
                    this.$normalRequest('player/cancelRegistrationSpecialCompetition', {
                        player_id: this.currentManagedPlayerId,
                        special_competition_id: this.info.special_competition_id
                    }, '已取消报名', true, this, 'operating').then(_ => {
                        this.reload();
                    }).catch(_ => {
                    });
                }).catch(() => {
                });
            }
        }
    };
</script>
